import React from "react";
import GwGraph from "./GwGraph"

function App() {
  return (
    <div>
      <GwGraph></GwGraph>
    </div>
  );
}

export default App;
